
const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://monthlymillionaireproject.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'The Monthly Millionaire Project',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/e62ab94b377030bab304226dbded8c13.jpeg',
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+234-913-789-7299',
          contactType: 'customer service',
          areaServed: 'NG',
          availableLanguage: 'English',
        },
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: '#2 Allen Avenue, Gabriel Akinmade Taylor Plaza, Near Toyin Roundabout, Ikeja, 3rd Floor, Winning Life Center',
        addressLocality: 'Lagos',
        addressRegion: 'LA',
        addressCountry: 'NG',
      },
      sameAs: ['https://wa.me/2349137897299'],
      email: 'themonthlymillionairesproject@gmail.com',
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'The Monthly Millionaire Project',
      description:
        'A proven structured health business system with mentorship to earn million naira monthly in Nigeria.',
      publisher: { '@id': `${SITE_URL}/#organization` },
      inLanguage: 'en-NG',
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: SITE_URL,
      name: 'The Monthly Millionaire Project Lagos | Earn Million Naira Monthly | Health Business Nigeria',
      description:
        'Join The Monthly Millionaire Project in Lagos Nigeria - A proven structured health business system with mentorship to earn million naira monthly. Apply now for Entry Path or Leadership Path.',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      about: { '@id': `${SITE_URL}/#organization` },
      inLanguage: 'en-NG',
      dateModified: '2025-07-14',
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#localbusiness`,
      name: 'The Monthly Millionaire Project',
      image:
        'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/e62ab94b377030bab304226dbded8c13.jpeg',
      url: SITE_URL,
      telephone: '+234-913-789-7299',
      email: 'themonthlymillionairesproject@gmail.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '#2 Allen Avenue, Gabriel Akinmade Taylor Plaza, Near Toyin Roundabout, Ikeja, 3rd Floor, Winning Life Center',
        addressLocality: 'Lagos',
        addressRegion: 'Lagos',
        addressCountry: 'NG',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 6.6,
        longitude: 3.35,
      },
      areaServed: {
        '@type': 'Country',
        name: 'Nigeria',
      },
      priceRange: '₦₦',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '10:00',
          closes: '15:00',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is The Monthly Millionaire Project?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The Monthly Millionaire Project (MMP) is a transformational initiative that helps individuals earn a million naira or more monthly through a structured health business system, mentorship, and capacity building in Nigeria.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I join the Monthly Millionaire Project?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'You can apply by filling out the application form on our website. There are two paths: the Entry Path for beginners and the Leadership Path for those ready to build large wellness teams.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is the Monthly Millionaire Project available outside Lagos?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. The Monthly Millionaire Project operates nationwide across Nigeria. Our headquarters in Lagos serves as the hub for training, mentorship, and business development.',
          },
        },
        {
          '@type': 'Question',
          name: 'What banking partners does the Monthly Millionaire Project use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The Monthly Millionaire Project works with Fidelity Bank and Access Bank as its official banking partners.',
          },
        },
      ],
    },
  ],
};

export default function SeoJsonLd() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
    />
  );
}
